export default "__VITE_ASSET__hIgYSCFC__"